;(function () {
  'use strict'

  angular.module('pub.drop.service', []).factory('DropsService', DropsService)

  /** @ngInject */
  function DropsService($http, $q, API) {
    function list(t, start, limit, sort) {
      var defered = $q.defer()

      let _sort = ''
      if (sort) {
        _sort = '&sort=' + sort
      }

      $http
        .get(API.API_URL + 'publisher/drops?t=' + t + '&start=' + start + '&limit=' + limit + _sort)
        .success(defered.resolve)

      return defered.promise
    }

    function listUnpublished(start, limit, sort) {
      var defered = $q.defer()

      let _sort = ''
      if (sort) {
        _sort = '&sort=' + sort
      }

      $http
        .get(API.API_URL + 'publisher/drops/unpublished?start=' + start + '&limit=' + limit + _sort)
        .success(defered.resolve)

      return defered.promise
    }

    function listPublished(start, limit, sort) {
      var defered = $q.defer()

      let _sort = ''
      if (sort) {
        _sort = '&sort=' + sort
      }

      $http
        .get(API.API_URL + 'publisher/drops/published?start=' + start + '&limit=' + limit + _sort)
        .success(defered.resolve)

      return defered.promise
    }

    function listAll(sort) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/drops?sort=' + sort).success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/drops/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/drops', model).success(defered.resolve)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http.put(API.API_URL + 'publisher/drops/' + id, model).success(defered.resolve)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http.delete(API.API_URL + 'publisher/drops/' + id).success(defered.resolve)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/drops/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/drops/' + id + '/unpublish').success(defered.resolve)

      return defered.promise
    }

    function saveSets(id, model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/drops/' + id + '/sets', model).success(defered.resolve)

      return defered.promise
    }

    return {
      list: list,
      listAll,
      get: get,
      save: save,
      saveSets,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      listUnpublished,
      listPublished,
    }
  }
})()
